import { token } from '@porsche-code/kado-styled-system/tokens';
import { Modal } from '@porsche-code/kado-ui';
import { PTabs, PTabsItem } from '@porsche-design-system/components-react';
import { CSSProperties, SVGProps, useCallback, useState } from 'react';

import { AssumeUser } from './AssumeUser';
import { isDevToolsActive } from './helper';
import KadoFillIcon from './static/kado-fill.svg?react';
import KadoOutlineIcon from './static/kado-outline.svg?react';

export const DevTools = ({ style }: { style?: CSSProperties }) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const handleModalOpen = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  const handleModalClose = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const props: SVGProps<SVGSVGElement> = {
    onClick: handleModalOpen,
    style: {
      bottom: 0,
      cursor: 'pointer',
      fontSize: token('fontSizes.xl'),
      margin: token('spacing.md'),
      position: 'fixed',
      right: 0,
      zIndex: token('zIndex.devTools'),
      ...style,
    },
  };

  return (
    <>
      {isDevToolsActive() ? (
        <KadoFillIcon {...props} />
      ) : (
        <KadoOutlineIcon {...props} />
      )}
      <Modal open={isModalOpen} onDismiss={handleModalClose}>
        <Modal.Header>DevTools</Modal.Header>

        <PTabs compact>
          <PTabsItem label="Assume User">
            <AssumeUser onClose={handleModalClose} />
          </PTabsItem>
        </PTabs>
      </Modal>
    </>
  );
};
